<div class="pg-message-text grit-message-text">
  <ng-content></ng-content>
</div>
